const stripeErrorCodes = [
    'account_closed',
    'account_country_invalid_address',
    'account_invalid',
    'account_error_country_change_requires_additional_steps',
    'account_number_invalid',
    'amount_too_large',
    'amount_too_small',
    'api_key_expired',
    'authentication_required',
    'balance_insufficient',
    'balance_invalid_parameter',
    'bank_account_bad_routing_numbers',
    'bank_account_declined',
    'bank_account_exists',
    'bank_account_verification_failed',
    'bank_account_unusable',
    'bank_account_unverified',
    'capture_charge_authorization_expired',
    'capture_unauthorized_payment',
    'card_decline_rate_limit_exceeded',
    'charge_already_captured',
    'charge_already_refunded',
    'charge_disputed',
    'charge_exceeds_source_limit',
    'charge_exceeds_transaction_limit',
    'charge_invalid_parameter',
    'country_unsupported',
    'country_code_invalid',
    'coupon_expired',
    'customer_max_subscriptions',
    'customer_max_payment_methods',
    'customer_tax_location_invalid',
    'shipping_address_invalid',
    'billing_invalid_mandate',
    'email_invalid',
    'idempotency_key_in_use',
    'financial_connections_account_inactive',
    'financial_connections_no_successful_transaction_refresh',
    'instant_payouts_unsupported',
    'instant_payouts_limit_exceeded',
    'instant_payouts_config_disabled',
    'payouts_limit_exceeded',
    'insufficient_funds',
    'invalid_characters',
    'invalid_card_type',
    'invoice_no_customer_line_items',
    'invoice_on_behalf_of_not_editable',
    'invoice_no_payment_method_types',
    'invoice_no_subscription_line_items',
    'invoice_not_editable',
    'invoice_payment_intent_requires_action',
    'invoice_upcoming_none',
    'no_account',
    'debit_not_authorized',
    'bank_account_restricted',
    'out_of_inventory',
    'parameter_invalid_empty',
    'parameter_invalid_integer',
    'parameter_invalid_string_blank',
    'parameter_invalid_string_empty',
    'parameter_missing',
    'parameter_unknown',
    'parameters_exclusive',
    'acss_debit_session_incomplete',
    'payment_method_billing_details_address_missing',
    'payment_method_unsupported_type',
    'payment_method_customer_decline',
    'payment_method_microdeposit_verification_attempts_exceeded',
    'intent_invalid_state',
    'intent_verification_method_missing',
    'payment_method_invalid_parameter',
    'payment_method_invalid_parameter_testmode',
    'payment_method_provider_timeout',
    'payment_method_provider_decline',
    'payment_method_microdeposit_verification_amounts_mismatch',
    'payment_method_microdeposit_verification_descriptor_code_mismatch',
    'payment_method_microdeposit_verification_amounts_invalid',
    'payment_method_microdeposit_failed',
    'payment_method_microdeposit_verification_timeout',
    'payment_method_bank_account_already_verified',
    'payment_method_bank_account_blocked',
    'payment_method_unactivated',
    'payment_method_currency_mismatch',
    'payment_method_unexpected_state',
    'payment_method_not_available',
    'payment_intent_unexpected_state',
    'payment_intent_incompatible_payment_method',
    'payment_intent_invalid_parameter',
    'payment_intent_mandate_invalid',
    'setup_intent_mandate_invalid',
    'invalid_mandate_reference_prefix_format',
    'payment_intent_konbini_rejected_confirmation_number',
    'payment_intent_authentication_failure',
    'payment_intent_payment_attempt_failed',
    'payment_intent_payment_attempt_expired',
    'setup_intent_setup_attempt_expired',
    'payment_intent_amount_reconfirmation_required',
    'payment_intent_automatic_tax_incomplete',
    'payment_intent_action_required',
    'platform_account_required',
    'setup_intent_authentication_failure',
    'setup_intent_unexpected_state',
    'setup_intent_invalid_parameter',
    'setup_attempt_failed',
    'status_transition_invalid',
    'payouts_not_allowed',
    'platform_api_key_expired',
    'postal_code_invalid',
    'refer_to_customer',
    'resource_already_exists',
    'resource_missing',
    'routing_number_invalid',
    'stripe_tax_inactive',
    'clearing_code_unsupported',
    'secret_key_required',
    'state_unsupported',
    'tax_id_invalid',
    'tax_id_prohibited',
    'terminal_location_country_unsupported',
    'terminal_reader_offline',
    'terminal_reader_timeout',
    'terminal_reader_busy',
    'terminal_reader_hardware_fault',
    'terminal_reader_invalid_location_for_activation',
    'terminal_reader_invalid_location_for_payment',
    'tls_version_unsupported',
    'token_already_used',
    'token_in_use',
    'transfers_not_allowed',
    'transfer_source_balance_parameters_mismatch',
    'url_invalid',
    'not_allowed_on_standard_account',
    'lock_timeout',
    'cardholder_phone_number_required',
    'return_intent_already_processed',
    'refund_disputed_payment',
    'progressive_onboarding_limit_exceeded',
    'forwarding_api_inactive',
    'forwarding_api_invalid_parameter',
    'forwarding_api_upstream_connection_timeout',
    'forwarding_api_upstream_connection_error',
    'forwarding_api_retryable_upstream_error',
    'forwarding_api_upstream_error',
    'alipay_upgrade_required',
    'bitcoin_upgrade_required',
    'card_declined',
    'charge_expired_for_capture',
    'expired_card',
    'incorrect_address',
    'incorrect_cvc',
    'incorrect_number',
    'incorrect_zip',
    'invalid_tax_location',
    'invalid_charge_amount',
    'invalid_cvc',
    'invalid_expiry_month',
    'invalid_expiry_year',
    'invalid_number',
    'invalid_source_usage',
    'livemode_mismatch',
    'missing',
    'processing_error',
    'product_inactive',
    'rate_limit',
    'sepa_unsupported_account',
    'shipping_calculation_failed',
    'sku_inactive',
    'taxes_calculation_failed',
    'testmode_charges_only',
];
const isStripeErrorCode = (code) => {
    return stripeErrorCodes.includes(code);
};
/**
 * @docs https://docs.stripe.com/error-codes
 */
export const mapStripeErrorCode = (code) => {
    if (!isStripeErrorCode(code)) {
        return 'unknown';
    }
    switch (code) {
        case 'payment_intent_authentication_failure':
        case 'setup_intent_authentication_failure':
        case 'authentication_required':
        case 'payment_intent_action_required':
        case 'invoice_payment_intent_requires_action':
        case 'payment_intent_amount_reconfirmation_required':
            return 'payment_authentication_failed';
        case 'payment_intent_unexpected_state':
        case 'setup_intent_unexpected_state':
        case 'payment_intent_payment_attempt_expired':
        case 'setup_intent_setup_attempt_expired':
        case 'capture_charge_authorization_expired':
        case 'charge_expired_for_capture':
            return 'payment_invalid';
        case 'card_declined':
        case 'expired_card':
        case 'balance_insufficient':
        case 'payment_method_provider_decline':
        case 'payment_method_customer_decline':
        case 'bank_account_declined':
        case 'bank_account_restricted':
        case 'payment_method_bank_account_blocked':
        case 'refer_to_customer':
        case 'payment_intent_payment_attempt_failed':
            return 'payment_declined';
        case 'incorrect_number':
        case 'incorrect_cvc':
        case 'invalid_cvc':
        case 'incorrect_zip':
        case 'incorrect_address':
        case 'invalid_card_type':
        case 'invalid_expiry_month':
        case 'invalid_expiry_year':
        case 'invalid_number':
            return 'invalid_card_details';
        case 'insufficient_funds':
            return 'insufficient_funds';
        case 'processing_error':
        case 'payment_method_provider_timeout':
        case 'forwarding_api_upstream_connection_timeout':
        case 'forwarding_api_upstream_connection_error':
        case 'forwarding_api_retryable_upstream_error':
        case 'forwarding_api_upstream_error':
            return 'processing_error';
        case 'parameter_invalid_empty':
        case 'parameter_invalid_integer':
        case 'parameter_invalid_string_blank':
        case 'parameter_invalid_string_empty':
        case 'parameter_missing':
        case 'parameter_unknown':
        case 'parameters_exclusive':
        case 'invalid_charge_amount':
        case 'invalid_source_usage':
        case 'payment_method_invalid_parameter':
        case 'payment_method_invalid_parameter_testmode':
        case 'payment_intent_invalid_parameter':
        case 'setup_intent_invalid_parameter':
        case 'url_invalid':
        case 'email_invalid':
            return 'invalid_request';
        case 'account_closed':
        case 'account_invalid':
        case 'bank_account_unusable':
        case 'bank_account_unverified':
        case 'no_account':
        case 'payouts_not_allowed':
        case 'transfers_not_allowed':
            return 'account_issue';
        case 'country_unsupported':
        case 'state_unsupported':
        case 'sepa_unsupported_account':
        case 'instant_payouts_unsupported':
        case 'terminal_location_country_unsupported':
        case 'payment_method_unsupported_type':
            return 'unsupported';
        case 'rate_limit':
        case 'card_decline_rate_limit_exceeded':
            return 'rate_limited';
        default:
            return 'unknown';
    }
};
//# sourceMappingURL=errors.js.map